'use strict';

import angular from 'angular';

const localStorageKey = 'lastBookingInfo';
const propertiesToRemove = [
  'currency',
  'price'
];

export default function f(localStorage) {
  'ngInject';

  return {
    saveBookingInfo: function (bookingInfo, location, extension) {
      const info = angular.copy(bookingInfo);

      propertiesToRemove.forEach((propertyName) => delete info[propertyName]);
      localStorage.set(localStorageKey + extension, JSON.stringify({
        booking: info,
        location: location
      }));
    },
    getBookingInfo: function (location, extension) {
      var bookingInfo = null;

      try {
        bookingInfo = JSON.parse(localStorage.get(localStorageKey + extension));
        if (bookingInfo.location.fullName !== location.fullName) {
          bookingInfo = null;
        }
      } catch (error) {
        bookingInfo = null;
      }

      return bookingInfo && bookingInfo.booking;
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/services/last_booking_info.js